import { useSelector } from 'react-redux';

import { DEFAULT_MINIMUM_SCHEDULED_TIME_SECONDS } from '@app/constants/organization';
import { StateType } from '@app/types/reducer-state';

export const useOrganizationId = () =>
  useSelector((state: StateType) => state?.organizations?._id || '');

export const useOrganization = () =>
  useSelector((state: StateType) => state?.organizations || {});

export const useOrganizationDisplayName = () =>
  useSelector(
    (state: StateType) =>
      state?.organizations?.displayName || state?.organizations?.name || '',
  );

export const useMinimumScheduledTime = () =>
  useSelector(
    (state: StateType) =>
      state?.organizations?.organizationSettings?.minimumScheduledTimeSeconds ??
      DEFAULT_MINIMUM_SCHEDULED_TIME_SECONDS,
  );

export const isFeatureOverrideEnabled = (
  featureOverrides: Record<string, { enabled?: boolean }> | undefined,
  featureName: string,
): boolean => featureOverrides?.[featureName]?.enabled === true;

export const useIsFeatureOverrideEnabled = (featureName: string): boolean =>
  useSelector((state: StateType) =>
    isFeatureOverrideEnabled(
      state?.organizations?.featureOverrides,
      featureName,
    ),
  );
